module.exports = __webpack_public_path__ + "static/media/scooter_break.972ae304.png";